import React from 'react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import { assetUrl } from '~/helpers';
import { elById } from '~/Share/Utils';
import { ReduxState } from '~/types/redux/share';

const Container = styled.div`
  width: 100%;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const ShareIcon = styled.div`
  height: 20px;
  width: 18px;
  text-align: center;

  svg {
    height: 17px;
    width: auto;

    path#ic_share {
      fill: #888;
    }
  }
`;

export type ShareButtonProps = {
  className?: string;
};

export default function ShareButton({ className }: ShareButtonProps) {
  const { shareModalClicked } = useSelector((state: ReduxState) => ({
    shareModalClicked: state.tracking.shareModalClicked,
  }));

  const onClick = () => {
    const sharingModal = elById('sharing-modal');
    sharingModal?.classList.add('in');

    shareModalClicked();
  };

  return (
    <Container onClick={onClick} className={className}>
      <ShareIcon>
        <img src={assetUrl('assets/images/icons/ic_share.svg')} />
      </ShareIcon>
    </Container>
  );
}
